import { StyledInputRoot, StyledInputElement } from "../../../../components/common/table/NumberInput.styles";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";

export default function IntegerPropertyEditor(props: PropertyEditorProps) {
    return <StyledInputRoot>
        <StyledInputElement
            className="numberInput"
            type="number"
            placeholder={"-"}
            value={props.value as number}
            onChange={(e) => props.onChanged(e.target.value !== "" ? Number(e.target.value) : undefined)} />
    </StyledInputRoot>
}